module.exports = __webpack_public_path__ + "img/cayman-machine-vision-poster.2de982d4.jpg";